export default {
  USER_CANCELLATION: 'userCancelled',
  USER_CONFIRMATION: 'userConfirmed',
}
